import React, { Component } from 'react'

import BkFlowNavigationProfileMenuError from '../BkFlowNavigationProfileMenuError'
import profileProviderLogo from '../../../../../assets/icons/profile-provider-logo.svg'
import getCookie from '../../../../../utilities/session/getCookie'
import { get } from 'lodash'
// import triggerCustomGaEvent from '../../../../utilities/analytics/triggerCustomGaEvent'

class BkFlowNavigationAccorProfileMenu extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	componentDidMount() {
		const currentTokenData = getCookie('accorAuthToken')
		const decodedTokenData = currentTokenData ? atob(currentTokenData) : null
		const parsedTokenDate = decodedTokenData ? JSON.parse(decodedTokenData) : null
		const enCodedToken = get(parsedTokenDate, 'id_token', null)
		const idToken = enCodedToken ? JSON.parse(atob(enCodedToken.split('.')[1])) : null
		const piSriToken = get(idToken, 'pi.sri', null)

		if (piSriToken) {
			document.cookie = `accorPiSriToken=${piSriToken}; max-age=3600; path=/`
		}
	}

	render() {
		const {
			configData,
			profileUser,
			profileUserError,
			handleFetchProfileUser,
			handleSignOutProfileUser,
			closeMenuEvent
		} = this.props

		document.addEventListener('keydown',function(e){
			if (e.keyCode === 27) {
				closeMenuEvent()
			}
		})

		// function handleMyAccountLink() {
		// 	window.open(profileManageAccountLink)
		// 	triggerCustomGaEvent('analytics-profileViewCrmAccount', true)
		// }

		const hotelLabels = configData.hotel.labels[0]

		let currentProfileUserName = null
		let	currentProfileUserTierUpgrade = null
		let	currentProfileUserNightsToUpgrade = null
		let profileCardClasses = 'bk-flow-navigation__profile-menu-card accor classic'
		// let profileManageAccountLink = '/my-account/'

		// if (process.env.REACT_APP_COMPONENT_PROFILE_MANAGE_ACCOUNT_LINK) {
		// 	profileManageAccountLink = process.env.REACT_APP_COMPONENT_PROFILE_MANAGE_ACCOUNT_LINK
		// }

		if (profileUser) {
			if(profileUser.firstName) {
				currentProfileUserName = profileUser.firstName

				if (profileUser.lastName) {
					currentProfileUserName = profileUser.firstName + ' ' + profileUser.lastName
				}
			}

			if (profileUser.loyaltyTier) {
				profileCardClasses = 'bk-flow-navigation__profile-menu-card accor ' + profileUser.loyaltyTier.toLowerCase()
			}

			if (profileUser.loyaltyTierUpgrade) {
				currentProfileUserTierUpgrade = profileUser.loyaltyTierUpgrade
			}

			if (profileUser.nightsToUpgrade) {
				currentProfileUserNightsToUpgrade = profileUser.nightsToUpgrade
			}
		}

		return  (
			<div className="bk-flow-navigation__profile-menu accor">
				{ !profileUser &&
					profileUserError &&
					<BkFlowNavigationProfileMenuError
						hotelLabels={hotelLabels}
						handleFetchProfileUser={handleFetchProfileUser}
					/>
				}

				{ currentProfileUserName &&
					<h6>
						{ hotelLabels && hotelLabels.hello ? hotelLabels.hello : 'Hi' }, { currentProfileUserName }
						<button
							className="btn btn-text-only"
							onClick={() => closeMenuEvent()}
						>
							<i className="material-icons">close</i>
						</button>
				</h6>
				}

				{ currentProfileUserNightsToUpgrade &&
					currentProfileUserTierUpgrade &&
					<div className="bk-flow-navigation__profile-menu-card-upgrade">
						<p className="u-remove-margin">{ hotelLabels && hotelLabels.stay ? hotelLabels.stay : 'Stay' } {currentProfileUserNightsToUpgrade} { hotelLabels && hotelLabels.loyaltyNightsUntilMessage ? hotelLabels.loyaltyNightsUntilMessage : 'more nights until you reach' } {currentProfileUserTierUpgrade} { hotelLabels && hotelLabels.loyaltyIncreaseSavingsMessage ? hotelLabels.loyaltyIncreaseSavingsMessage : 'and increase your savings' }.</p>
					</div>
				}

				{profileUser &&
				!profileUserError &&
					<div className="bk-flow-navigation__profile-menu-card-actions">
						<img src={profileProviderLogo} alt="Accor All"/>
						{/*<button*/}
						{/*	className="btn"*/}
						{/*	onClick={() => handleMyAccountLink()}*/}
						{/*>*/}
						{/*	{hotelLabels && hotelLabels.myAccount ? hotelLabels.myAccount : 'My Account'}*/}
						{/*</button>*/}
					</div>
				}

				{ profileUser &&
					profileUser.loyaltyId &&
					<div className="bk-flow-navigation__profile-menu-card-details">
						<div className={profileCardClasses}>
							{profileUser.loyaltyTier &&
								<p className="u-font-bold">{profileUser.loyaltyTier}</p>
							}

							{profileUser.loyaltyRewardsPoints &&
								<p className="u-remove-margin u-font-bold">{ hotelLabels && hotelLabels.points ? hotelLabels.points : 'Points' }: {profileUser.loyaltyRewardsPoints}</p>
							}

							{profileUser.loyaltyId &&
								<p className="u-remove-margin u-font-bold">N<sup>o</sup> {profileUser.loyaltyId}</p>
							}
						</div>
					</div>
				}

				<div className="bk-flow-navigation__profile-menu-card-logout">
					<button
						className="btn"
						onClick={() => handleSignOutProfileUser() }
					>
						{ hotelLabels && hotelLabels.signOut ? hotelLabels.signOut : 'Sign Out' }
					</button>
				</div>
			</div>
		)
	}
}

export default BkFlowNavigationAccorProfileMenu


// WEBPACK FOOTER //
// ./src/components/structure/navigation/profile/elements/BkFlowNavigationAccorProfileMenu.js